// These values identify public service endpoints. They are intentionally safe
// to ship in the browser and APK; private provider keys remain server-side.
export const SUPABASE_URL = "https://zufwllpknjtdpqgqhifp.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_2oYgacPWTg3_IHG5t15Avw_uBNS0IZ2";
export const AQUA_PUBLIC_APP_URL = "https://draw.aquahomesdesigngroup.com/";
export const AQUA_PORTAL_FUNCTION_URL = `${SUPABASE_URL}/functions/v1/aquadraw-portal`;
export const AQUA_REALTIME_FUNCTION_URL = `${SUPABASE_URL}/functions/v1/aquadraw-aqua-realtime`;

export function buildClientPortalUrl(clientId: string, portalToken: string, publicAppUrl = AQUA_PUBLIC_APP_URL) {
  const normalizedClientId = clientId.trim();
  const normalizedToken = portalToken.trim();
  if (!/^[0-9a-f-]{36}$/i.test(normalizedClientId)) throw new Error("A valid client portal identifier is required.");
  if (!/^[A-Za-z0-9_-]{40,256}$/.test(normalizedToken)) throw new Error("A secure client portal token is required.");
  const url = new URL(publicAppUrl);
  if (url.protocol !== "https:") throw new Error("The client portal must use a secure HTTPS address.");
  url.search = "";
  url.hash = new URLSearchParams({ portalClient: normalizedClientId, portalToken: normalizedToken }).toString();
  return url.toString();
}
